import React, { useState, Fragment, useEffect } from "react";
import {
  BrowserRouter as Router,
  Link,
  useLocation
} from "react-router-dom";

import axios from 'axios';
import { Card, Grid, CircularProgress } from "@material-ui/core";
import Canvas from '../flowApp';
import { AppBarHeaderDummy } from "../components/AppBarDummy";
import { fetchAllApps } from "../features/allApps/allAppsSlice";
import { useDispatch } from "react-redux";

const Editor = () => {



  const colors = [
    'primary',
    'secondary',
  ];
  const dispatch = useDispatch()
  
  useEffect(() => {
    dispatch(fetchAllApps(1))
  }, [])

  const [color, setColor] = useState(0);

  useEffect(() => {
    if (loading === true) {
      const interval = setInterval(() => {
        setColor((v) => (v === 2 ? 0 : v + 1));
      }, 1500);
    }
  }, []);

  const [djangoId, setDjangoId] = useState(null);
  const [loading, setLoading] = useState('initializing');

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  let query = useQuery();
  const id = query.get("id")
  const userFromQuery = query.get("u");
  const tenantFromQuery = query.get("t");
  // applyDashboardAuthFromUrl() (index.js) copies u/t/c into localStorage and strips only c from the URL.
  // Only persist when present in the query — never write null or we clobber auth.
  if (userFromQuery != null && String(userFromQuery).trim() !== "") {
    try {
      localStorage.setItem("user", userFromQuery);
    } catch (_) {}
  }
  if (tenantFromQuery != null && String(tenantFromQuery).trim() !== "") {
    try {
      localStorage.setItem("tenant", tenantFromQuery);
    } catch (_) {}
  }

  const getDjangoWorkflow = () => {
    var config = {
      method: 'get',
      url: 'https://7nx4ewphyg.execute-api.us-west-2.amazonaws.com/production/docdb/scaffolddjangomap?scaffoldId=' + id,
      headers: {
        'Content-Type': 'application/json'
      }

    };
    axios(config)
      .then(function (response) {
        var datalength = response.data.length;
        if (datalength === 0) {
          //if the scaffoldmapper doesn't return anything, create a fresh workflow

          setLoading('loaded');
        }
        else {
          //get the frontendWorkflow using id from the above function and return the workflow
          var idfromdjango = response.data[0].djangoId;
          setDjangoId(idfromdjango)
          setLoading('loaded');
        }
      })
      .catch(function (error) {
        setLoading('loaded');
      });
  }

  useEffect(() => {
    if (loading != 'loaded') {
      getDjangoWorkflow()
    } else {

    }
  }, [loading])


  return (
    <div style={{ paddingTop: 0, paddingLeft: 0 }}>
      <Grid >
        <Grid >
          <Card style={{ spacing: 2, paddingTop: 0 }}>
            {loading != 'loaded' ? <Fragment>
              <div style={{ width: '100vw', height: '100vh' }}>
                <AppBarHeaderDummy />
                <CircularProgress style={{ left: '50%', top: '50%', position: 'absolute' }} id='circularprogresscolor' color={colors[color]} size={50} />
              </div>
            </Fragment>
              :
              <div id='canvas-editorjsxpage' style={{ width: '100vw', height: '100vh' }}>
              
                <Canvas workflowID={djangoId} />
              </div>}
          </Card>
        </Grid>
      </Grid>
    </div>

  );
};

export default Editor;